"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeArray = mergeArray;
exports.spliceFileName = spliceFileName;
exports.downloadCanvasAsImage = downloadCanvasAsImage;
exports.isDefined = isDefined;
exports.getUidFromRemoteUser = getUidFromRemoteUser;
exports.getNumericLocalUid = getNumericLocalUid;
exports.normalizeMediaOptions = normalizeMediaOptions;
function mergeArray(dest, src) {
    for (let i = 0; i < src.length; i++) {
        dest.push(src[i]);
    }
}
//get file name from a file path
function spliceFileName(filePath) {
    let lastIndex = 0;
    lastIndex = filePath.lastIndexOf('/');
    if (lastIndex == -1) {
        lastIndex = filePath.lastIndexOf('\\');
    }
    let fileName;
    if (lastIndex == -1) {
        fileName = filePath;
    }
    else {
        fileName = filePath.substring(lastIndex + 1);
    }
    return fileName;
}
//
function downloadCanvasAsImage(canvas, fileName) {
    let dataUrl = canvas.toDataURL('image/jpeg', 1.0);
    let a = document.createElement('a');
    a.href = dataUrl;
    a.download = fileName;
    a.click();
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function getUidFromRemoteUser(user) {
    let remoteUid;
    //if joinchannel with string uid
    if (typeof user.uid === 'string') {
        //@ts-ignore websdk private property
        remoteUid = user._uintid;
    }
    else {
        remoteUid = user.uid;
    }
    return remoteUid;
}
// AUDIT-v18: estrae uid numerico dal _joinInfo del client (user-account mode).
// Centralizzato per non duplicare @ts-ignore access ovunque e semplificare
// eventuale refactor futuro se il nome private field cambia.
function getNumericLocalUid(agoraRTCClient) {
    var _a;
    if (!agoraRTCClient)
        return undefined;
    if (agoraRTCClient.isStringUID) {
        return (_a = agoraRTCClient._joinInfo) === null || _a === void 0 ? void 0 : _a.uid;
    }
    const uid = agoraRTCClient.uid;
    return typeof uid === 'number' ? uid : undefined;
}
// AUDIT-v18: normalizza ChannelMediaOptions. Il Dart SDK invia
// publishScreenCaptureVideo, il codice internal key su publishScreenTrack.
// Centralizziamo l'aliasing qui invece di duplicarlo in IrisClientState e
// ImplHelper. Mutazione in-place: nessun overhead di spread.
function normalizeMediaOptions(options) {
    if (!options)
        return options;
    if (options.publishScreenCaptureVideo !== undefined &&
        options.publishScreenTrack === undefined) {
        options.publishScreenTrack = options.publishScreenCaptureVideo;
    }
    return options;
}
